import { useRecoilValue } from "recoil";
import {
  getSpecificStandaloneFetalSexCardState,
  getSpecificStandaloneFetalSexResult,
} from "../../recoil/selectors";
import {
  StandaloneFetalSexCardState,
  StandaloneFetalSexResultSerializer,
} from "../../recoil/types";

interface StandaloneFetalSexCardData {
  cardState: StandaloneFetalSexCardState | undefined;
  result?: StandaloneFetalSexResultSerializer | null;
}

export const useStandaloneFetalSexResult = (
  requisitionID: string,
): StandaloneFetalSexCardData => {
  const cardState = useRecoilValue(
    getSpecificStandaloneFetalSexCardState(requisitionID),
  );
  const result = useRecoilValue(
    getSpecificStandaloneFetalSexResult(requisitionID),
  );

  return {
    cardState,
    result,
  };
};
